import { hasScope } from '../utils/auth';
import { FILE_MANAGER_WRITE_SCOPE } from '../Constants';
export const getShouldStripImageBlobs = (stripImageBlobs = false, scopes) => stripImageBlobs && !hasScope(FILE_MANAGER_WRITE_SCOPE, scopes);